export const MCP_CLIENT_CONFIG_TEMPLATE = `{
  "mcpServers": {
    "{serverName}": {
      "url": "{mcpUrl}"
    }
  }
}`
